var styles = {"legal":"styles_legal__2pOIw center col-8","link":"styles_link__34VSC"};

export default styles;
//# sourceMappingURL=styles.css.js.map
